<template>
  <div class="address-warp">
    <div class="container" v-if="list.length > 0">
      <van-radio-group v-model="selectList">
        <van-swipe-cell
          :name="index"
          :before-close="beforeClose"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="address-item">
            <van-radio :name="index"></van-radio>
            <div class="item-info">
              <h4>{{ item.name }}</h4>
              <p>税号：{{ item.taxNumber }}</p>
            </div>
            <div class="item-right">
              <div class="item-edit" @click="edit(item)">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5947 2.15137L14.0869 1.64551C14.3193 1.40625 14.3262 1.07129 14.0938 0.845703L13.9365 0.681641C13.7246 0.469727 13.3828 0.49707 13.1641 0.71582L12.665 1.20801L13.5947 2.15137ZM5.72656 9.26074L7.05957 8.67969L13.0889 2.65039L12.1523 1.72754L6.12988 7.75684L5.51465 9.04199C5.45996 9.1582 5.59668 9.31543 5.72656 9.26074ZM2.88965 14.3467H10.915C12.1387 14.3467 12.8564 13.6357 12.8564 12.2275V4.61914L11.7559 5.71973V12.1729C11.7559 12.8838 11.3662 13.2461 10.8945 13.2461H2.90332C2.21973 13.2461 1.84375 12.8838 1.84375 12.1729V4.41406C1.84375 3.70312 2.21973 3.33398 2.90332 3.33398H8.81641L9.91699 2.2334H2.88965C1.46094 2.2334 0.743164 2.94434 0.743164 4.35254V12.2275C0.743164 13.6426 1.46094 14.3467 2.88965 14.3467Z"
                    fill="#367CCC"
                  />
                </svg>
              </div>
            </div>
          </div>
          <template #right>
            <van-button square text="删除" type="danger" class="delete-button" />
          </template>
        </van-swipe-cell>
      </van-radio-group>
    </div>
    <!-- 空状态 -->
    <div class="default-state" v-else>
      <div class="state-content">
        <svg
          class="prefix__prefix__icon"
          width="50"
          height="50"
          viewBox="0 0 1201 1024"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1046 365.12c12.693 23.434-15.097-41.55-64.308-41.55l-761.35.3a73.321 73.321 0 0 0-64.593 39.898C139.195 389.695-.011 604.398-.011 649.798v291.86a82.619 82.619 0 0 0 82.86 82.334h1036a82.619 82.619 0 0 0 82.86-82.334v-291.86c0-45.456-155.75-284.74-155.75-284.74zM774.03 627.26a38.621 38.621 0 0 0-39.297 28.767c0 2.103.3 4.206.3 6.31a134.74 134.74 0 1 1-269.47 0c0-2.705.3-5.334.451-8.038a42.391 42.391 0 0 0-38.32-27.039H71.814l120.46-221.87s22.082-39.823 53.192-38.62h717.81c25.011 0 29.292 9.013 47.333 38.62l122.46 222.08H774.05zM341.4 206.85l-91.632-86.916a24.53 24.53 0 1 1 33.814-35.541l91.512 86.916a24.5 24.5 0 0 1-33.739 35.541m252.27-38.395a24.41 24.41 0 0 1-7.586-17.125l-3.305-126.18a24.545 24.545 0 0 1 49.061-1.277l3.23 126.18a24.485 24.485 0 0 1-41.325 18.402m237.34 33.89a24.485 24.485 0 0 1-.901-34.64l86.916-91.633a24.591 24.591 0 0 1 35.692 33.844l-86.916 91.632a24.485 24.485 0 0 1-34.64.901"
            fill="#C2C2C2"
          />
        </svg>
        还没有发票信息
      </div>
    </div>

    <div class="add-bar" v-if="list.length <= 4">
      <div class="container">
        <van-button type="primary" block @click="addInvoice">新增发票抬头</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/components/axios";

export default {
  data() {
    return {
      id: this.$route.query.id || null,
      list: [],
      selectList: "",
    };
  },
  created() {
    this.getData();
  },
  watch: {
    $route: "getData",
    selectList(index) {
      if (index !== "") {
        const invoice = this.list[index];
        console.log(invoice);
        this.$store.commit("storeInvoice", invoice);
        this.$router.push({
          path: "/invoice-info",
          query: {
            id: this.id,
          },
        });
        this.selectList = "";
      }
    },
  },
  methods: {
    getData() {
      api.get("/invoice_info").then((res) => {
        if (res.data.code === 200) {
          this.list = res.data.data;
        }
      });
    },
    beforeClose({ name, position, instance }) {
      switch (position) {
        case "left":
        case "cell":
        case "outside":
          instance.close();
          break;
        case "right":
          this.$dialog
            .confirm({
              message: "确定删除吗？",
            })
            .then(() => {
              //删除操作
              const { id } = this.list[name];
              this.handleDelete(id);
              this.list.splice(name, 1);
              instance.close();
            });
          break;
      }
    },
    edit(invoice) {
      this.$router.push({
        path: `/invoice-edit/${invoice.id}`,
        query: {
          id: this.id,
        },
      });
    },
    addInvoice() {
      this.$router.push({
        path: "/invoice-create",
        query: {
          id: this.id,
        },
      });
    },
    handleDelete(id) {
      api.delete(`/invoice_info/${id}`).then((res) => {
        if (res.data.code === 200) {
          this.$toast.success("删除成功！");
        }
      });
    },
  },
};
</script>
<style lang="less">
.back-btn,
.footer {
  display: none;
}
.van-swipe-cell {
  .delete-button {
    height: 100%;
    border-radius: 10px;
  }
  .van-button::before {
    display: none;
  }
}

.van-submit-bar .van-submit-bar__text {
  & > .van-submit-bar__price {
    margin-right: 4px;
  }
  .van-submit-bar__suffix-label {
    text-decoration: line-through;
    color: #999;
    font-size: 12px;
  }
}
</style>
